export const BLOG_POSTS = [
  {
    slug: "what-is-the-axis",
    title: "What Is the Axis?",
    excerpt: "A secular ethical framework built on three non-negotiable principles — and an organization of people prepared to act on them.",
    date: "2026-10-07",
    category: "Philosophy",
    author: "Temüjin",
    image: null, // import and place image here: import PostImg from '../../images/your-image.jpg'
    pullQuote: "Caring, in the absence of a shared ethical language and the willingness to act, produces noise rather than force.",
    content: [
      "The Axis is a secular ethical framework. Not a religion, not a political party, not a self-help system. A framework — a coherent set of principles that, when applied consistently, produce a particular way of moving through the world.",
      "Those principles are three. We call them the Sacred Three: Life, the Planet, and the Social Contract. They are not arbitrary. They are the foundational conditions for human existence and human dignity. Damage any one of them severely enough and the others follow. All three are currently under sustained, deliberate assault.",
      "The Axis exists because the response to that assault has been inadequate. Not because people do not care — many do. But caring, in the absence of a shared ethical language, a coherent structure, and the willingness to act, produces noise rather than force.",
      "The Axis is an attempt to change that. To build the language. To build the structure. To find the people who are prepared to act within it.",
      "This is not a movement in the contemporary sense — trending hashtags, performance outrage, symbolic gestures that cost nothing and change nothing. It is an organization. Organizations have members, standards, obligations, and the capacity to coordinate sustained action over time. That is what we are building.",
      "If you are reading this, you already know something is wrong. The question the Axis asks is the harder one: what are you prepared to do about it?"
    ],
    links: [
      // { text: "Read more: The Sacred Three", url: "/blog/the-sacred-three" },
      // { text: "External reference title", url: "https://example.com" }
    ]
  },
  {
    slug: "the-sacred-three",
    title: "The Sacred Three",
    excerpt: "Three things the Axis holds to be non-negotiable — not as preferences, not as politics, but as the conditions of a livable world.",
    date: "2026-10-07",
    category: "Philosophy",
    author: "Temüjin",
    image: null, // placeholder
    pullQuote: "The current approach — treat the planet as an infinite resource and an infinite dump simultaneously — is not a policy disagreement. It is civilizational suicide conducted in slow motion.",
    content: [
      "Three things are sacred within the Axis. Not metaphorically sacred — not 'we care about these things' sacred. Sacred in the sense that their violation is not acceptable under any framing, for any justification, at any price.",
      "Life. The Planet. The Social Contract.",
      "Life first, because without it nothing else is possible. The Axis holds all living things to have inherent worth — not because they are useful, not because they belong to a protected category, but because existence itself carries weight. The systematic devaluation of life — human, animal, ecological — is not a side effect of modern civilization. It is a feature of systems that treat living things as inputs. We reject that framing entirely.",
      "The Planet second, because it is the substrate. Every economic system, every civilization, every human project exists inside the natural world. The current approach — treat the planet as an infinite resource and an infinite dump simultaneously — is not a policy disagreement. It is civilizational suicide conducted in slow motion. The Axis does not negotiate with that premise.",
      "The Social Contract third, because we are not isolated. We exist in relation. The Social Contract is the architecture of that relation — the mutual obligations, the shared trust, the understanding that a functioning society requires people to take their responsibilities to each other seriously. When that contract is abandoned by those with power, it is always the powerless who pay. The Axis holds the Social Contract to be not merely useful but essential, and its systematic destruction to be among the gravest threats we face.",
      "These three are not a checklist. They are a lens. Every decision, every system, every action passes through them. When something violates one, the Axis says so. When it violates all three — which is more common than it should be — the Axis acts."
    ],
    links: [
      // { text: "Read more: Change Yourself First", url: "/blog/change-yourself-first" },
    ]
  },
  {
    slug: "change-yourself-first",
    title: "Change Yourself First",
    excerpt: "The first stage of the Axis mission is the one most people want to skip. It is also the one nothing else is built without.",
    date: "2026-10-07",
    category: "Mission",
    author: "Temüjin",
    image: null, // placeholder
    pullQuote: "You cannot organize what you have not first embodied.",
    content: [
      "The Axis mission moves through four stages. The first is the one people most want to skip.",
      "Change yourself.",
      "It is easy to see what is wrong with the world. It requires nothing — no courage, no sacrifice, no sustained effort. Diagnosis is available everywhere and costs nothing. The harder question is whether the person doing the diagnosing has actually applied those same standards to themselves. Whether their own decisions, their consumption, their relationships, their treatment of other people are in alignment with the principles they claim to hold.",
      "Most of the time, they are not. Not through malice — through inattention. Through the gap between stated values and lived behavior that everyone has to some degree and almost no one examines honestly.",
      "The Axis begins here. Not because personal transformation will save the world on its own — it will not. But because you cannot organize what you have not first embodied. You cannot ask others to hold to a standard you are not holding yourself. You cannot build a coherent ethical community out of people who have not done the internal work.",
      "This is not a preparation phase with a finish line. It is permanent. The examination continues. The standard applies. You hold yourself to it because it is true, not because it is easy, and not because you will always succeed.",
      "What it looks like in practice is not complicated. It means examining your choices against the Sacred Three — your consumption, your work, your relationships, your use of power over others, your treatment of the natural world. Not perfectly. Not with paralysis. But honestly, and with the willingness to change what needs to change.",
      "The world will not be changed by people who have exempted themselves from their own principles."
    ],
    links: [
      // { text: "Read more: What Is the Axis?", url: "/blog/what-is-the-axis" },
    ]
  }
];


/*export const BLOG_POSTS = [
  {
    slug: "welcome",
    title: "Welcome to Your App Name",
    excerpt: "A quick overview of what this platform is and where it's going.",
    date: "2026-02-06",
    content: [
      "This is an example blog post.",
      "Replace this text with your real content.",
      "Add CTA buttons, screenshots, and links as needed."
    ]
  },
  {
    slug: "privacy-security",
    title: "Privacy & Security First",
    excerpt: "How we think about safety, identity, and account protection.",
    date: "2026-02-06",
    content: [
      "We design features with security defaults.",
      "Use strong passwords, MFA, and rate limiting on the backend.",
      "This post is placeholder content." 
    ]
  },
  {
    slug: "roadmap",
    title: "Roadmap",
    excerpt: "What we plan to ship next.",
    date: "2026-02-06",
    content: [
      "Posts, DMs, and admin news are the foundation.",
      "Next: push notifications, better media handling, and performance improvements.",
      "This post is placeholder content." 
    ]
  }
];*/
